import CriteriaView from "./CriteriaView";

export default CriteriaView;
